module.exports = __webpack_public_path__ + "img/bcc151.2f9aea7d.jpeg";